import { TextInput } from '@mantine/core';
import React, { useEffect, useState } from 'react';

interface CurrencyInputProps {
  value: number; // cents
  currencySymbol?: string;
  onChange: (value: number) => void;
  disabled?: boolean;
  label?: string;
}

const CurrencyInput: React.FC<CurrencyInputProps> = ({ value, currencySymbol, onChange, disabled, label }) => {
  const format = (cents: number) => (cents / 100).toFixed(2).replace('.', ',');

  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setInputValue(`${format(value)} ${currencySymbol ?? ''}`);
  }, [value, currencySymbol]);

  const toCents = (v: string) => {
    const cleaned = v
      .replace(currencySymbol ?? '', '')
      .replace(/\s/g, '')
      .replace(',', '.');

    const parsed = parseFloat(cleaned);

    return isNaN(parsed) ? 0 : Math.round(parsed * 100);
  };

  const handleBlur = () => {
    onChange(toCents(inputValue));
  };

  return (
    <TextInput
      label={label}
      disabled={disabled}
      value={inputValue}
      onChange={e => setInputValue(e.currentTarget.value)}
      onBlur={handleBlur}
    />
  );
};

export default CurrencyInput;
